/* eslint-disable no-nested-ternary */
import React from 'react';
import { pathOr } from 'ramda';
import { array, object, bool, func } from 'prop-types';

import AssigneesList from '../assignees-list';
import SearchAssignees from './search-assignees';

import {
  Title,
  Arrow,
  AssignBtn,
  HeaderWrapper,
  PopoverWrapper,
  AssigneesEmptyList,
  ManageAssigneesBtn,
  AssigneesListWrapper,
  ManageAssigneesBtnWrapper,
} from './styled-components';
import { Popconfirm } from '../../../../popovers';
import { filterUsers } from '../../../../../utils';
import { DropdownAction } from '../../../../ui-helpers';

export function ManageAssignees({
  users,
  assignees,
  showSearch,
  setShowSearch,
  onAddAssignee,
  onRemoveAssignee,
  requestTasks,
  tasks,
}) {
  const currentUserId = localStorage.getItem('userId');
  const userFollowProject = !!assignees.find(item => item === currentUserId);
  const isSales = pathOr('', [currentUserId, 'role'], users) === 'sales-agent';

  return (
    <PopoverWrapper
      onClick={(e) => { e.stopPropagation(); }}
    >
      <HeaderWrapper>
        <Title>Assignees</Title>
        {userFollowProject && isSales ? (
          <Popconfirm
            title="You will lose access to this request when you're unassigned, continue?"
            onConfirm={() => onRemoveAssignee(currentUserId)}
          >
            <DropdownAction width="initial" data-popconfirm-stay-open>
              <AssignBtn >
            - Unassign me
              </AssignBtn>
            </DropdownAction>
          </Popconfirm>

        ) : userFollowProject ? (
          <AssignBtn onClick={() => onRemoveAssignee(currentUserId)}>
          - Unassign me
          </AssignBtn>
        )
          : (
            <AssignBtn
              onClick={() => { onAddAssignee(currentUserId); }}
            >
            + Assign me
            </AssignBtn>
          )}
      </HeaderWrapper>
      <AssigneesListWrapper>
        {assignees.length
          ? (<div style={{ display: 'flex', flexDirection: 'inherit' }}>
            <AssigneesList
              wrapperStyles
              users={users}
              assignees={assignees}
              currentUserId={currentUserId}
              onRemoveAssignee={onRemoveAssignee}
              requestTasks={requestTasks}
              tasks={tasks}
            />
          </div>)
          : <AssigneesEmptyList>
            It seems like no one is responsible for this Request...
          </AssigneesEmptyList>
        }

        <ManageAssigneesBtnWrapper>
          <ManageAssigneesBtn
            onClick={() => setShowSearch(!showSearch)}
          >
            Manage Assignees
            <Arrow type="down" rotate={showSearch ? 180 : 0} />
          </ManageAssigneesBtn>
        </ManageAssigneesBtnWrapper>

        {
          showSearch &&
          <SearchAssignees
            users={filterUsers(users)}
            followers={assignees}
            currentUserId={currentUserId}
            onAddAssignee={onAddAssignee}
          />
        }
      </AssigneesListWrapper>
    </PopoverWrapper>
  );
}

ManageAssignees.propTypes = {
  users: object.isRequired,
  showSearch: bool.isRequired,
  assignees: array.isRequired,
  setShowSearch: func.isRequired,
  onAddAssignee: func.isRequired,
  onRemoveAssignee: func.isRequired,
  requestTasks: array,
  tasks: object,
};

ManageAssignees.defaultProps = {
  requestTasks: null,
  tasks: null,
};



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/manage-assignees/index.js